import { Component, inject } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatError, MatFormField, MatHint, MatLabel} from '@angular/material/form-field';
import { HttpErrorResponse } from '@angular/common/http';

import {MatButton, MatIconButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../../services/auth.service';
import {passwordComplexityValidator} from '../../../../shared/validators/password-complexity.validator';
import {matchValidator} from '../../../../shared/validators/match.validator';
import { SNACKBAR_DURATION } from '../../../../shared/constants/snackbar.constants';

@Component({
  selector: 'tgrid-reset-password-modal',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatError,
    MatLabel,
    MatButton,
    MatInput,
    MatDialogClose,
    MatIcon,
    MatIconButton,
    MatHint,
],
  templateUrl: './reset-password-modal.component.html',
  standalone: true,
  styleUrls: ['../../../../../style/modal.scss', './reset-password-modal.component.scss'],
})
export class ResetPasswordModalComponent {
  dialogRef = inject<MatDialogRef<ResetPasswordModalComponent>>(MatDialogRef);
  data = inject<{
    userId: number;
}>(MAT_DIALOG_DATA);


  private authService = inject(AuthService);
  private snackbar = inject(MatSnackBar);
  protected formGroup = new FormGroup({
      password: new FormControl<string>('', {
        nonNullable: true,
        validators: Validators.required,
        asyncValidators: passwordComplexityValidator(this.authService),
      }),
      confirm: new FormControl<string>('', {nonNullable: true, validators: Validators.required}),
    }, {
      validators: matchValidator('password', 'confirm'),
    },
  );


  protected resetPassword(): void {
    const password: string = this.formGroup.controls.password.value;
    this.authService.changePassword(this.data.userId, password).subscribe({
      next: () => {
        this.snackbar.open('Your password has been changed.', 'X', { duration: SNACKBAR_DURATION.MEDIUM });
        this.dialogRef.close(true);
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.snackbar.open('There was an error resetting your password', '', { duration: SNACKBAR_DURATION.MEDIUM });
      },
    });
  }
}
